import React, { useState, useEffect } from 'react';

const SplashScreen = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prev => {
        const newProgress = prev + Math.random() * 5;
        if (newProgress >= 100) {
          clearInterval(timer);
          setTimeout(() => setIsLoading(false), 500);
          return 100;
        }
        return newProgress;
      });
    }, 100);

    return () => clearInterval(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#FFFFFF',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
      transition: 'opacity 0.5s ease-out'
    }}>
      {/* Logo 动画 */}
      <div style={{
        width: '120px',
        height: '120px',
        marginBottom: 'var(--space-8)',
        position: 'relative',
        animation: 'logoSpin 2s ease-in-out infinite'
      }}>
        <img 
          src="/logo.jpg" 
          alt="御林安全工作室"
          style={{
            width: '100%',
            height: '100%',
            borderRadius: 'var(--radius-2xl)',
            objectFit: 'cover',
            boxShadow: 'var(--shadow-brand)',
            border: '4px solid rgba(139, 69, 19, 0.3)'
          }}
        />
        <div style={{
          position: 'absolute',
          top: '-8px',
          left: '-8px',
          right: '-8px',
          bottom: '-8px',
          borderRadius: 'var(--radius-2xl)',
          border: '2px solid transparent',
          background: 'linear-gradient(45deg, #8B4513, #A0522D, #8B4513) border-box',
          mask: 'linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)',
          maskComposite: 'exclude',
          animation: 'borderRotate 3s linear infinite'
        }} />
      </div>

      {/* 标题动画 */}
      <h1 style={{
        fontSize: '2.5rem',
        fontWeight: 'var(--font-black)',
        marginBottom: 'var(--space-6)',
        background: 'var(--gradient-brand)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        textAlign: 'center'
      }}>
        <span style={{ display: 'block', animationDelay: '0.1s' }}>御林安全工作室</span>
        <span style={{ 
          fontSize: '1rem', 
          fontWeight: 'var(--font-medium)',
          display: 'block',
          animationDelay: '0.3s'
        }}>Yulin Security Studio</span>
      </h1>

      {/* 进度条 */}
      <div style={{
        width: '200px',
        height: '4px',
        backgroundColor: 'var(--bg-tertiary)',
        borderRadius: 'var(--radius-full)',
        overflow: 'hidden',
        position: 'relative'
      }}>
        <div style={{
          width: `${progress}%`,
          height: '100%',
          backgroundColor: 'var(--brand)',
          borderRadius: 'var(--radius-full)',
          transition: 'width 0.3s ease',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: '-100%',
            width: '100%',
            height: '100%',
            background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)',
            animation: 'progressShine 1.5s ease-in-out infinite'
          }} />
        </div>
      </div>

      {/* 加载文本 */}
      <p style={{
        marginTop: 'var(--space-4)',
        color: 'var(--text-secondary)',
        fontSize: '0.9rem',
        animation: 'pulse 1.5s ease-in-out infinite'
      }}>
        正在加载安全世界...
      </p>

      {/* 数字雨效果 */}
      <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden' }}>
        {[...Array(30)].map((_, index) => {
          const left = Math.random() * 100;
          const delay = Math.random() * 3;
          const duration = Math.random() * 2 + 2;
          const opacity = Math.random() * 0.4 + 0.1;
          const fontSize = Math.random() * 8 + 10;
          
          return (
            <div
              key={index}
              style={{
                position: 'absolute',
                left: `${left}%`,
                top: '-50px',
                fontFamily: 'monospace',
                fontSize: `${fontSize}px`,
                color: `rgba(139, 69, 19, ${opacity})`,
                whiteSpace: 'nowrap',
                animation: `rainFall ${duration}s linear infinite`,
                animationDelay: `${delay}s`,
                textShadow: '0 0 5px rgba(139, 69, 19, 0.3)'
              }}
            >
              {[...Array(Math.floor(Math.random() * 8) + 5)].map((_, i) => (
                <div key={i} style={{ 
                  animation: `binaryFlicker ${Math.random() * 0.5 + 0.3}s ease-in-out infinite`,
                  animationDelay: `${Math.random() * 2}s`
                }}>
                  {Math.random() > 0.5 ? '1' : '0'}
                </div>
              ))}
            </div>
          );
        })}
      </div>

      <style jsx global>{`
        @keyframes logoSpin {
          0%, 100% {
            transform: rotate(0deg) scale(1);
          }
          50% {
            transform: rotate(5deg) scale(1.05);
          }
        }

        @keyframes borderRotate {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes progressShine {
          0% {
            left: -100%;
          }
          100% {
            left: 100%;
          }
        }

        @keyframes rainFall {
          0% {
            transform: translateY(-100px);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          90% {
            opacity: 1;
          }
          100% {
            transform: translateY(100vh);
            opacity: 0;
          }
        }

        @keyframes binaryFlicker {
          0%, 100% {
            opacity: 0.3;
          }
          50% {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default SplashScreen;